import { Product, ProductConfiguration } from "@/modules/facturae/domain/Product";
import { ProductListScreenData } from "../domain/ProductListScreenData";

export const DEFAULT_HEADERS = [
            {
                text: "Código",
                sortable: true,
                value: "code",
                width:100,
            },
            {
                text: "Descripción",
                sortable: true,
                value: "description",
                width:350,
            },
            {
                text: "Precio de coste",
                sortable: false,
                value: "cost_price",
                width:100,
            },
            {
                text: "Precio unitario",
                sortable: false,
                value: "price",
                width:100,
            },
            {
                text: "IVA/IGIC",
                sortable: false,
                value: "taxes",
                width:100,
            },
            {
                text: "Tipo 0%",
                sortable: false,
                value: "special_taxable_event",
                width:100,
            },
            {
                text: "Retención",
                sortable: false,
                value: "taxes_withheld",
                width:100,
            },
            {
                text: "Descuento",
                sortable: false,
                value: "discount",
                width:100,
            },
            {
                text: "Precio final",
                sortable: false,
                value: "final_price",
                width:175,
            },
            {
                text: '',
                align: 'end',
                sortable: false,
                value: 'actions',
                width:1,
            },
        ]; 

export class VueProductListScreenData implements ProductListScreenData{
    products: Product[];
    product: Product;
    products_headers: any[];
    selectedItems: Array<Object>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    totalItems: number;
    tableHeight: string;
    limit: number;
    snackbar: Object;
    search: string;
    loadingAddProduct: boolean;
    showAddProductDialog: boolean;
    dirty: string[];
    loadingProducts: {};
    deletePopup: boolean;
    loadingDeleteProduct: boolean;
    tax_type:string;
    loadingUploadProducts: boolean;
    uploadProductsJobId: number;
    uploadProductsJobState: String;
    dialogUploadProducts: boolean;
    file: any;
    configurationPopup: boolean;
    productConfiguration: ProductConfiguration;
    import_errors: string[];
    import_errors_dialog: boolean;

    constructor(){
        this.products = []
        this.product = null
        this.products_headers = DEFAULT_HEADERS.slice(),
        this.selectedItems = [];
        this.loadingItems = false;
        this.footerItemsPerPageText = "Registros por página:";
        this.footerItemsPerPageOptions = [5, 10, 50, 100];
        this.showSelect = false;
        this.textNoResults = "No se han encontrado registros";
        this.textLoading = "Cargando...";
        this.itemKey = "id";
        this.hideHeaderCheckbox = false;
        this.mobile = false;
        this.totalItems = 0;
        this.tableHeight = '59vh';
        this.limit = 10;
        this.snackbar = {
            isVisible: false,
            text: '',
            color: '',
            timeout: 3000,
          }
        this.showAddProductDialog = false;
        this.loadingAddProduct = false;
        this.dirty = []
        this.loadingProducts = {}
        this.deletePopup = false
        this.loadingDeleteProduct = false
        this.tax_type = 'iva/igic'
        this.loadingUploadProducts = false;
        this.uploadProductsJobId = 0
        this.uploadProductsJobState = 'done'
        this.dialogUploadProducts = false;
        this.file = null;
        this.configurationPopup = false;
        this.productConfiguration = null;
        this.import_errors = [];
        this.import_errors_dialog = false;
    }

    success_message(message: string){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message: string){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    setLoading(loading:boolean){
        this.loadingItems = loading
    }

    setProducts(products: Product[]){
        this.products = products
        if (products.length == 0){
            this.showSelect = false
        } else {
            this.showSelect = true
        }
    }

    setProduct(product: Product): void {
        this.product = product
    }

    setTotalItems(totalItems: number){
        this.totalItems = totalItems
    }

    changeLimit(value) {
        this.limit = value;
        this.calculateTableHeight();
    }

    calculateTableHeight() {
        let initNumItemsPerPage = Math.min(this.limit, 10);
        if (this.totalItems == 0) {
            this.tableHeight = '20vh';
        }
        else {
            let tempTableHeight = 48 * (Math.min(this.totalItems, initNumItemsPerPage) + 1);
            this.tableHeight = (tempTableHeight).toString() + 'px'
        }
    }
    
    setAddProductDialogVisibility(visible: boolean) : void {
        this.showAddProductDialog = visible
    }

    setLoadingAddProduct(loading: boolean) : void {
        this.loadingAddProduct = loading
    }

    setDirty(product_id:string): void {
        this.dirty.push(product_id)
    }

    removeDirty(product_id: string): void {
        this.dirty = this.dirty.filter((id) => id != product_id)
    }

    isDirty(product_id: string): boolean {
        return this.dirty.includes(product_id)
    }

    changeLoadingProduct(id: string, value: boolean): void {
        let cp = Object.assign({}, this.loadingProducts)
        cp[id] = value
        this.loadingProducts = cp
    }

    toggleDeletePopup(show: boolean): void {
        this.deletePopup = show
    }

    setLoadingDeleteProduct(loading: boolean): void {
        this.loadingDeleteProduct = loading
    }
    setLoadingUploadProducts(loading: boolean): void {
        this.loadingUploadProducts = loading
    }

    setUploadProductsJobId(job_id): void {
        this.uploadProductsJobId = job_id;
    }
    setUploadProductsJobState(state): void {
        this.uploadProductsJobState = state;
    }

    setConfigurationPopupVisibility(visible: boolean): void {
        this.configurationPopup = visible;
    }

    setProductConfiguration(config: ProductConfiguration): void {
        this.productConfiguration = config;
    }

    getFixedProductHeaders() {
        const fixedValues = ['code', 'description', 'price', 'taxes', 'special_taxable_event', 'taxes_withheld', 'discount', 'final_price'];
        return this.products_headers.filter(h => fixedValues.includes(h.value));
    }

    getAdditionalFields() {
        if (!this.productConfiguration || !this.productConfiguration.fields) {
            return [];
        }
        return this.productConfiguration.fields.map(field => ({
            name: field.name,
            key: field.key
        }));
    }

    addAdditionalField(name: string, key: string): boolean {
        if (!this.productConfiguration) {
            return false;
        }
        // Check for duplicate keys
        if (this.productConfiguration.fields.some(f => f.key === key)) {
            return false;
        }
        this.productConfiguration.fields.push({ name, key });
        return true;
    }

    removeAdditionalField(key: string): void {
        if (!this.productConfiguration) {
            return;
        }
        this.productConfiguration.fields = this.productConfiguration.fields.filter(f => f.key !== key);
    }

    updateAdditionalField(oldKey: string, name: string, key: string): boolean {
        if (!this.productConfiguration) {
            return false;
        }
        // Check for duplicate keys (excluding the current field)
        if (oldKey !== key && this.productConfiguration.fields.some(f => f.key === key)) {
            return false;
        }
        const field = this.productConfiguration.fields.find(f => f.key === oldKey);
        if (field) {
            field.name = name;
            field.key = key;
            return true;
        }
        return false;
    }

    reorderAdditionalFields(fields: any[]): void {
        if (!this.productConfiguration) {
            return;
        }
        this.productConfiguration.fields = fields.map(f => ({ name: f.name, key: f.key }));
    }

    setImportErrors(errors: string[]): void {
        this.import_errors = errors;
    }

    clearImportErrors(): void {
        this.import_errors = [];
    }

    setImportErrorsDialogVisibility(visible: boolean): void {
        this.import_errors_dialog = visible;
    }
}